import React from 'react';

import Box from '@mui/material/Box';

import { KnzComponentProps } from '../../types';

/**
 * カード等を横並びにするレイアウト（knz 独自の新規コンポーネント）。
 * params: columns（任意, 列数。デフォルト 2）
 * children: 横並びにするブロック
 */
export const Grid: React.FC<KnzComponentProps> = ({ node, renderChildren }) => {
  const columnsRaw = node.params.columns as string | undefined;
  const columns = columnsRaw ? Math.max(1, parseInt(columnsRaw, 10) || 2) : 2;

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: `repeat(${columns}, 1fr)` },
        gap: 1.5,
      }}
    >
      {renderChildren(node.children)}
    </Box>
  );
};

export default Grid;
